var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"tabindex":"-1"}},[_c('AppDownloadBanner'),_c('LtImagesSnack'),_c('router-view'),_c('GlobalModal'),_c('GlobalSnack'),_c('ErrorModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }